export enum Error {
    None = 'No Error',
    NotFound = 'No Found',
    PartialSaveError = 'Partial Save Error',
    BadRequest = 'Bad Request',
    Unknown = 'Unknown',
    InternalError = 'Internal Server Error'
}
